import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";

export const RequisitionTableForm = ({
    emptyMessage = "",
    tableColumns,
    data,
    setData,
    selectedData,
    setSelectedData,
    loading = true,
    dataKey,
    actionButton,
    dialog,
    isColor,
    actionButtonWidth = 2,
    body,
    autoLayout = true,
    actionHeader,
    sticky,
    ...rest
}) => {
    /**@emptyMessage => if no data found message */
    /**@tableColumns => tableColumns you want*/
    /**@data / @setData => state for table data*/
    /**@loading / @setLoading => loading state=> true / false*/
    /** @selectedData / @setSelectedData => state for selected data */
    /** @showModal / @setShowModal => state for modal */
    /** @dataKey => unique id of the field */
    /** @actionButton => Action button of the field */
    /** @dialog => method for dialog box*/

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (typeof data === "undefined" || data === null) {
            return setTableData([]);
        }
        setTableData(data);
    }, [data]);

    const price = (data) => {
        let total_price = 0
        for (let i=0; i < data.length; i ++){
            total_price = total_price + (data[i]?.quantity * data[i]?.unit_price)
        }
        return total_price
    }



    return (
        <div className={`p-grid table table2 ${sticky && "sticky"}`}>
            <div className="p-col-12">
                <div className="card">
                    <DataTable
                        className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers "
                        value={data}
                        dataKey={dataKey}
                        rowHover
                        selection={selectedData}
                        onSelectionChange={(e) => setSelectedData?.(e.value)}
                        emptyMessage={emptyMessage}
                        loading={loading}
                        header={null}
                        resizableColumns
                        columnResizeMode="expand"
                        showGridlines
                        stripedRows
                        // autoLayout={autoLayout}
                        // responsiveLayout="scroll"
                        selectionMode="checkbox"
                        selectionAutoFocus={false}
                        {...rest}
                    >
                        {tableColumns?.map((col, i) => (
                            <Column key={i} field={col.field} header={col.header} body={col.sortableBody} style={{ minWidth: col.minWidth }} onRowClick={null}></Column>
                        ))}
                        {actionButton && <Column body={actionButton} header={actionHeader || "Action"} headerStyle={{ textAlign: "center", width: `${actionButtonWidth}rem` }}></Column>}
                    </DataTable>
                </div>
            </div>
        </div>
    );
};
